// Synchronous stub. Goes in <head>. Must stay tiny — every byte ships on every page.
//
// Two jobs only:
//   1. Define window.amb() so the host page can configure / track / setUser
//      before the async loader has arrived, and have those calls queued.
//   2. Subscribe to early window error / unhandledrejection so we don't lose
//      crashes that happen between <head> and the loader resolving.
//
// Loader injection is opt-in via `data-src` on the inline <script> that
// hosts this stub — keeps the stub usable for hosts that prefer to control
// script tag ordering themselves (e.g. via their own asset bundler).

(function (w, d) {
  if (w.amb) return;

  var GLOBAL = 'amb';
  var q = [];
  var earlyErrors = [];

  function amb() {
    q.push([].slice.call(arguments));
  }
  amb.q = q;
  amb.eq = earlyErrors;            // early-error queue, drained by loader
  amb.l = +new Date();             // stub load time, for self-monitoring
  amb.v = '__SDK_VERSION__';
  w[GLOBAL] = amb;

  // Capture errors that fire before the loader registers its own handlers.
  // Using addEventListener (not assigning .onerror) keeps the host page's own
  // handlers intact, and `true` for capture catches errors from cross-origin
  // scripts whose .error object the host page can't see.
  try {
    w.addEventListener('error', function (e) {
      if (earlyErrors.length > 32) return;       // bound memory while we wait
      earlyErrors.push({
        k: 'error',
        m: e && e.message,
        s: e && e.filename,
        l: e && e.lineno,
        c: e && e.colno,
        st: e && e.error && e.error.stack,
        t: +new Date()
      });
    }, true);

    w.addEventListener('unhandledrejection', function (e) {
      if (earlyErrors.length > 32) return;
      var r = e && e.reason;
      earlyErrors.push({
        k: 'rejection',
        m: r && (r.message || String(r)),
        st: r && r.stack,
        t: +new Date()
      });
    });
  } catch (_) { /* silent — RUM must never break the host page */ }

  // Optional script injection. Authors can write:
  //   <script src="/path/to/ambilobe-rum-stub.min.js" data-src="/path/to/ambilobe-rum.min.js" data-app="my-app" async></script>
  // and the stub will pull in the async loader. If `data-src` is absent the
  // host is expected to inject the loader themselves.
  try {
    var current = d.currentScript;
    if (current) {
      amb.cfg = {
        appId:       current.getAttribute('data-app')        || null,
        environment: current.getAttribute('data-env')        || 'production',
        release:     current.getAttribute('data-release')    || null,
        endpoint:    current.getAttribute('data-endpoint')   || null,
        sample:      current.getAttribute('data-sample')     || null,
        loaderSrc:   current.getAttribute('data-src')        || null,
        nonce:       current.nonce || current.getAttribute('nonce') || null
      };
      if (amb.cfg.loaderSrc) {
        var s = d.createElement('script');
        s.async = true;
        s.src = amb.cfg.loaderSrc;
        var sri = current.getAttribute('data-integrity');
        if (sri) { s.integrity = sri; s.crossOrigin = 'anonymous'; }
        if (amb.cfg.nonce) s.nonce = amb.cfg.nonce;
        (d.head || d.documentElement).appendChild(s);
      }
    }
  } catch (_) { /* silent */ }
})(window, document);
